import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';

import { LoadingLogoModule } from '@virginmediao2/momentum-angular';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { BaseComponent } from '../base/base.component';
import { AuthService } from '@/shared/services';
import { IdentificationService } from '@/shared/feature/universal-identification/services/identification.service';

@Component({
  selector: 'vm-auth-deflection',
  templateUrl: './auth-deflection.component.html',
  standalone: true,
  imports: [CommonModule, LoadingLogoModule],
})
export class AuthDeflectionComponent extends BaseComponent implements OnInit {
  private isBrowser: any = isPlatformBrowser(inject(PLATFORM_ID));

  private identificationService = inject(IdentificationService);
  private authService = inject(AuthService);

  ngOnInit() {
    if (this.isBrowser) {
      sessionStorage?.removeItem('vmo2_zeus_previous_url')
      const checkAuthInterval = setInterval(() => {
        if (this.authService.isAuthenticated()) {
          clearTimeout(redirectToAppStart);
          clearInterval(checkAuthInterval);

          const pingFedAccess = sessionStorage.getItem(this.identificationService.getPingFedAccessToken());
          this.identificationService.findPingFedUser(pingFedAccess).subscribe(() => {
            this.navigationService.toReturnUrl();
          });
        }
      }, 100);

      const redirectToAppStart = setTimeout(() => {
        clearInterval(checkAuthInterval);
        clearTimeout(redirectToAppStart);

        this.navigationService.toAppStart();
      }, 505);
    }
  }
}
